import * as types from '../mutation-types'
import { API } from '../../api'
import { FORMAT } from '../../data/core/format'
import { FATE_DATA_MANAGER, RECORD_DATA_MANAGER } from '../../data'
import { MOMENT_TIME } from '../../momenttime'

export default {
    namespaced: true,
    state: {
        editedStatus: false,
        editPersonInfo: {},
        editFateInfo: {},
        editFateListData: []
    },
    getters: {},
    mutations: {
        [types.EDIT_DETAIL_INIT_DATA](state) {
            // 暂存编辑页面数据:object的方式在不会重写
            var detailData = AppFate.$store.state.detail;
            var detailFFData = AppFate.$store.state.detail.fatefortune;
            state.editPersonInfo = Object.assign({}, detailData.personInfo);
            state.editFateInfo = Object.assign({}, detailFFData.fateInfo);
            state.editFateListData = [].concat(detailFFData.fateListData);
            console.log("types.EDIT_DETAIL_INIT_DATA---", state.editPersonInfo, state.editFateListData);
        },
        [types.EDIT_DETAIL_UPDATE_DATA](state, type) {
            // console.log("types.EDIT_DETAIL_UPDATE_DATA---", type);
            state.editedStatus = true;
            var formData = AppFate.$store.state.collate.formData;
            switch(type){
                // 修改性别
                case 'sex':
                    state.editFateInfo.sex = formData.sex;
                    AppFate.$store.state.editChangeBirthday = true;
                    // console.log('update------', formData.sex)
                    break;
                // 修改分组
                case 'group':
                    formData.f_group = AppFate.$store.state.group.chooseId;
                    break;
                // 修改出生地和出生时间
                case 'location':
                case 'birthday':
                    // 1. 更新表单数据
                    var location = formData.location,
                        birthday = MOMENT_TIME.getUnixTimeByTimeStr(formData.birthday);
                    formData.real_time = location == '' ? 0 : FORMAT.getRealSunTimeByData(location, birthday);
    
                    // 2. 更新命盘数据
                    state.editFateListData.splice(0);  //先清空数据
                    state.editFateListData = FATE_DATA_MANAGER.updateDetailFateDataByData(formData);
                    AppFate.$store.state.editChangeBirthday = true;
                    // console.log('update------', location, state.editFateListData)
                    break;
                // 修改早晚子时
                case 'zwzs':
                    // 1. 更新表单数据
                    formData.zwzs = state.editPersonInfo.zwzs;
                    console.log('update------', state.editPersonInfo, formData.zwzs)
                    AppFate.$store.state.editChangeBirthday = true;
    
                    // 2. 更新命盘数据
                    state.editFateListData.splice(0);  //先清空数据
                    state.editFateListData = FATE_DATA_MANAGER.updateDetailFateDataByData(formData);
                    AppFate.$store.state.editChangeBirthday = true;
                break;
                default:
                    break;
            }
        },
        [types.EDIT_DETAIL_SAVE_DATA](state) {
            var formData = AppFate.$store.state.collate.formData,
                labelData = AppFate.$store.state.label;
            // 处理标签
            formData.label = labelData.selectedLabelId;
            
            var params = Object.assign({
                id: state.editPersonInfo.id
            }, formData);
            console.log("types.EDIT_DETAIL_SAVE_DATA---", formData, state.editPersonInfo);
    
            API.updatePaiPan(params, function(data){
                AppFate.$toast("修改成功");
                // 重置数据
                AppFate.$store.dispatch('collate/resetData');
                AppFate.$store.dispatch('edit/resetData');
                AppFate.$store.dispatch('detail/resetData');
                // 修改成功后更新命盘数据并跳转至命盘页
                AppFate.$store.dispatch('detail/initDetail', data);
                // 更新列表数据
                AppFate.$store.dispatch('record/updateRecordListData', data);
                // 更新分组数据
                var groupData = AppFate.$store.state.group.groupData;
                var recordData = RECORD_DATA_MANAGER.getRecordDataByData(data, groupData);
                AppFate.$store.dispatch('group/updateGroupListData', recordData);
                // 处理过滤列表数据
                AppFate.$store.dispatch('record/updateRecordFilterList');
                // 处理跳转页面
                var path = AppFate.$router.history.current.path;
                path = path.replace('edit', 'detail');
                AppFate.$router.replace(path);
            });
        },
        [types.EDIT_DETAIL_RESET_DATA](state) {
            state.editedStatus = false;
            state.editPersonInfo = {};
            state.editFateInfo = {};
            state.editFateListData.splice(0);
        }
    },
    actions: {
        initEditDetail({ commit }){
            commit(types.EDIT_DETAIL_INIT_DATA);
        },
        updateEditDetail({ commit }, type){
            commit(types.EDIT_DETAIL_UPDATE_DATA, type);
        },
        saveEditDetail({ commit }){
            commit(types.EDIT_DETAIL_SAVE_DATA);
        },
        resetData({ commit }){
            commit(types.EDIT_DETAIL_RESET_DATA)
        }
    }
}